export enum ListActionBehavior {

    /**
     * Reload the list, scroll the affected row into view, and notify the user
     * when the record is not among the rendered rows.
     */
    Default = "DEFAULT",

    /**
     * Pin the list to the affected model(s): the list shows exactly those records
     * until the pin is cleared, regardless of the active filter, sort or page.
     */
    Filter = "FILTER"
}
